import { Link } from "react-router-dom";
import { Instagram, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, SITE, LOCATIONS } from "../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-charcoal text-stone-300">
    <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 sm:grid-cols-2 lg:grid-cols-4">
      <div className="space-y-4">
        <Logo dark />
        <p className="text-sm leading-relaxed text-stone-400">
          Ayam goreng basah khas Bandung — diungkep bumbu kuning, digoreng
          sebentar, disajikan panas dengan jukut goreng dan dua sambal khas.
        </p>
        <a
          href={SITE.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram-link"
          className="inline-flex items-center gap-2 font-mono text-sm font-bold text-bumbu-bright transition-colors hover:text-canvas"
        >
          <Instagram className="h-4 w-4" aria-hidden="true" />
          {SITE.instagramHandle}
        </a>
      </div>

      <nav aria-label="Navigasi footer">
        <h2 className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.2em] text-bumbu-bright">
          Jelajah
        </h2>
        <ul className="space-y-2.5 text-sm">
          {NAV.map((item) => (
            <li key={item.href}>
              <Link to={item.href} data-testid={`footer-${item.testid}`} className="transition-colors hover:text-canvas">
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div>
        <h2 className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.2em] text-bumbu-bright">
          Outlet
        </h2>
        <ul className="space-y-5 text-sm">
          {LOCATIONS.map((loc) => (
            <li key={loc.id} className="space-y-1">
              <p className="font-heading font-bold text-canvas">{loc.name}</p>
              <p className="flex items-start gap-1.5 text-stone-400">
                <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                {loc.address}
              </p>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h2 className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.2em] text-bumbu-bright">
          Catatan
        </h2>
        <p className="text-sm leading-relaxed text-stone-400">
          Jam operasional dan harga dapat berubah sewaktu-waktu. Info terbaru
          selalu diumumkan di Instagram resmi{" "}
          <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" className="text-bumbu-bright hover:text-canvas">
            {SITE.instagramHandle}
          </a>
          .
        </p>
      </div>
    </div>

    <div className="border-t border-dashed border-stone-700">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-5 py-5 text-center font-mono text-xs text-stone-500 sm:flex-row sm:text-left">
        <p>© 2026 Ayam Goreng Bandung Bu Iyin</p>
        <p>Melawai, Jakarta Selatan · Fresh Market Emerald Bintaro</p>
      </div>
    </div>
  </footer>
);
